/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useHydratedProps, withLayout, withLayoutAccordion, mergeProductClientOnlyProduct }
from '@thd-olt-component-react/fusion-utils';

import { RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withMagicApronTNT } from '@thd-olt-component-middleware/pip';

import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleF6Index0K0Header }
from '@thd-olt-component-react/product-overview';

import { SpecificationsAccordionTitle as SpecificationsAccordionTitleF6Index1K0Header }
from '@thd-olt-component-react/specifications';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleF6Index2K0Header }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleF6Index3K0Header }
from '@thd-olt-component-react/ratings-and-reviews';

const lazySlots = {};
const getPlaceholder = ({ skip }) => {
  if (skip) return null;
  return (
    <Skeleton>
      <SkeletonBlock />
      <SkeletonLine />
    </Skeleton>
  );
};

const SlotD6Placeholder0 = null;

const SlotD6Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "augmentedreality" */
    '@thd-olt-component-react/augmented-reality');
};

export const SlotD6Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/augmented-reality'))
      .AugmentedReality;
  },
  client: SlotD6Index0Client,
  placeholder: SlotD6Placeholder0 || getPlaceholder({ skip: true }),
  name: 'AugmentedReality',
});

lazySlots.LazyAugmentedRealityD6 = withLayout(

  [

    SlotD6Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotD6Index0Client,
      placeholder: SlotD6Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotE4Placeholder0 = null;

const SlotE4Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "consumercardmessaging" */
    '@thd-olt-component-react/consumer-card-messaging');
};

export const SlotE4Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/consumer-card-messaging'))
      .ConsumerCardMessaging;
  },
  client: SlotE4Index0Client,
  placeholder: SlotE4Placeholder0 || getPlaceholder({ skip: true }),
  name: 'ConsumerCardMessaging',
});

lazySlots.LazyConsumerCardMessagingE4 = withLayout(

  [

    SlotE4Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotE4Index0Client,
      placeholder: SlotE4Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotE7Placeholder0 = null;

const SlotE7Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "aislebay" */
    '@thd-olt-component-react/aisle-bay');
};

export const SlotE7Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/aisle-bay'))
      .AisleBay;
  },
  client: SlotE7Index0Client,
  placeholder: SlotE7Placeholder0 || getPlaceholder({ skip: true }),
  name: 'AisleBay',
});

lazySlots.LazyAisleBayE7 = withLayout(

  [

    SlotE7Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotE7Index0Client,
      placeholder: SlotE7Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotE8Placeholder0 = null;

const SlotE8Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "supersku" */
    '@thd-olt-component-react/super-sku');
};

export const SlotE8Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/super-sku'))
      .SuperSku;
  },
  client: SlotE8Index0Client,
  placeholder: SlotE8Placeholder0 || getPlaceholder({ skip: true }),
  name: 'SuperSku',
});

lazySlots.LazySuperSkuE8 = withLayout(

  [

    SlotE8Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotE8Index0Client,
      placeholder: SlotE8Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotE9Placeholder0 = null;

const SlotE9Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "ordersample" */
    '@thd-olt-component-react/order-sample');
};

export const SlotE9Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/order-sample'))
      .OrderSample;
  },
  client: SlotE9Index0Client,
  placeholder: SlotE9Placeholder0 || getPlaceholder({ skip: true }),
  name: 'OrderSample',
});

lazySlots.LazyOrderSampleE9 = withLayout(

  [

    SlotE9Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotE9Index0Client,
      placeholder: SlotE9Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotE10Placeholder0 = null;

const SlotE10Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "globalcustomconfigurator" */
    '@thd-olt-component-react/global-custom-configurator');
};

export const SlotE10Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/global-custom-configurator'))
      .GlobalCustomConfigurator;
  },
  client: SlotE10Index0Client,
  placeholder: SlotE10Placeholder0 || getPlaceholder({ skip: true }),
  name: 'GlobalCustomConfigurator',
});

lazySlots.LazyGlobalCustomConfiguratorE10 = withLayout(

  [

    SlotE10Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotE10Index0Client,
      placeholder: SlotE10Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotE12Placeholder0 = null;

const SlotE12Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "returnsmessaging" */
    '@thd-olt-component-react/returns-messaging');
};

export const SlotE12Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/returns-messaging'))
      .ReturnsMessaging;
  },
  client: SlotE12Index0Client,
  placeholder: SlotE12Placeholder0 || getPlaceholder({ skip: true }),
  name: 'ReturnsMessaging',
});

lazySlots.LazyReturnsMessagingE12 = withLayout(

  [

    SlotE12Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotE12Index0Client,
      placeholder: SlotE12Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF5Placeholder0 = null;

const SlotF5Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "botprompt" */
    '@thd-olt-component-react/magic-apron');
};

export const SlotF5Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
      .BotPrompt;
  },
  client: SlotF5Index0Client,
  placeholder: SlotF5Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_F5 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_F5 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_F5, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'above-accordion' } });

lazySlots.LazyBotPromptF5 = withLayout(

  [

    SlotF5Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_F5
  ,

  [

    {
      waitForComponent: SlotF5Index0Client,
      placeholder: SlotF5Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF6Placeholder0K0 = null;

const SlotF6Index0ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/product-overview');
};

export const SlotF6Index0LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
      .ProductOverviewAccordionBody;
  },
  client: SlotF6Index0ClientK0,
  placeholder: SlotF6Placeholder0K0 || getPlaceholder({ skip: true }),
  name: 'ProductOverviewAccordionBody',
});

lazySlots.LazyProductOverviewAccordionBodyF6 = withLayout(
  SlotF6Index0LoadK0,

  null
  ,
  {
    waitForComponent: SlotF6Index0ClientK0,
    placeholder: SlotF6Placeholder0K0 || getPlaceholder({ skip: true })
  }
);

const SlotF6Placeholder1K0 = null;

const SlotF6Index1ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/specifications');
};

export const SlotF6Index1LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
      .SpecificationsWithKPFAccordionBody;
  },
  client: SlotF6Index1ClientK0,
  placeholder: SlotF6Placeholder1K0 || getPlaceholder({ skip: true }),
  name: 'SpecificationsWithKPFAccordionBody',
});

lazySlots.LazySpecificationsWithKPFAccordionBodyF6 = withLayout(
  SlotF6Index1LoadK0,

  null
  ,
  {
    waitForComponent: SlotF6Index1ClientK0,
    placeholder: SlotF6Placeholder1K0 || getPlaceholder({ skip: true })
  }
);

const SlotF6Placeholder2K0 = null;

const SlotF6Index2ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/questions-and-answers');
};

export const SlotF6Index2LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
      .QuestionsAndAnswersAccordionBody;
  },
  client: SlotF6Index2ClientK0,
  placeholder: SlotF6Placeholder2K0 || getPlaceholder({ skip: true }),
  name: 'QuestionsAndAnswersAccordionBody',
});

lazySlots.LazyQuestionsAndAnswersAccordionBodyF6 = withLayout(
  SlotF6Index2LoadK0,

  null
  ,
  {
    waitForComponent: SlotF6Index2ClientK0,
    placeholder: SlotF6Placeholder2K0 || getPlaceholder({ skip: true })
  }
);

const SlotF6Placeholder3K0 = null;

const SlotF6Index3ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/ratings-and-reviews');
};

export const SlotF6Index3LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
      .RatingsAndReviewsAccordionBody;
  },
  client: SlotF6Index3ClientK0,
  placeholder: SlotF6Placeholder3K0 || getPlaceholder({ skip: true }),
  name: 'RatingsAndReviewsAccordionBody',
});

lazySlots.LazyRatingsAndReviewsAccordionBodyF6 = withLayout(
  SlotF6Index3LoadK0,

  null
  ,
  {
    waitForComponent: SlotF6Index3ClientK0,
    placeholder: SlotF6Placeholder3K0 || getPlaceholder({ skip: true })
  }
);

const LazyF6Accordion = withLayoutAccordion([
  [

    [

      withLayout(
        ProductOverviewAccordionTitleF6Index0K0Header,

      ),

    ],

    [

      withLayout(
        SpecificationsAccordionTitleF6Index1K0Header,

      ),

    ],

    [

      withLayout(
        QuestionsAndAnswersAccordionTitleF6Index2K0Header,

      ),

    ],

    [

      withLayout(
        RatingsAndReviewsAccordionTitleF6Index3K0Header,

      ),

    ],

  ],
  [

    [

      lazySlots.LazyProductOverviewAccordionBodyF6,

    ],

    [

      lazySlots.LazySpecificationsWithKPFAccordionBodyF6,

    ],

    [

      lazySlots.LazyQuestionsAndAnswersAccordionBodyF6,

    ],

    [

      lazySlots.LazyRatingsAndReviewsAccordionBodyF6,

    ],

  ]
],

null
);

const SlotF7Placeholder0 = null;

const SlotF7Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "botprompt" */
    '@thd-olt-component-react/magic-apron');
};

export const SlotF7Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
      .BotPrompt;
  },
  client: SlotF7Index0Client,
  placeholder: SlotF7Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_F7 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_F7 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_F7, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'default', default: true } });

lazySlots.LazyBotPromptF7 = withLayout(

  [

    SlotF7Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_F7
  ,

  [

    {
      waitForComponent: SlotF7Index0Client,
      placeholder: SlotF7Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

// to be generated by ejs based on config
export const DynamicImporter = (props) => {
  const { storeId, storeZip } = useStore();
  const slot = props.config.slots[props.slot];
  const components = slot.isAccordion
    ? slot.components.flat().map((sc) => sc.components).flat()
    : slot.components.flat();

  // todo use merge option?
  const hydratedProps = useHydratedProps(components, { itemId: props.itemId });
  components.forEach((com, index) => {
    // eslint-disable-next-line no-param-reassign
    com.props = hydratedProps[index];
  });

  const merge = mergeProductClientOnlyProduct;

  // use this for debugging, attache to queryProvider prop

  // const queryOptions = ({ options, queryName }) => {
  //   return {
  //     ...options,
  //     fetchPolicy: 'cache-only'
  //   };
  // };

  if (props.slot === 'slotD6') {

    return (
      <lazySlots.LazyAugmentedRealityD6
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotD6"
        fusionComponentName="@thd-olt-component-react/augmented-reality"
        version="7.5.1"
      />
    );

  }

  if (props.slot === 'slotE4') {

    return (
      <lazySlots.LazyConsumerCardMessagingE4
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotE4"
        fusionComponentName="@thd-olt-component-react/consumer-card-messaging"
        version="9.9.8"
      />
    );

  }

  if (props.slot === 'slotE7') {

    return (
      <lazySlots.LazyAisleBayE7
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotE7"
        fusionComponentName="@thd-olt-component-react/aisle-bay"
        version="7.11.1"
      />
    );

  }

  if (props.slot === 'slotE8') {

    return (
      <lazySlots.LazySuperSkuE8
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotE8"
        fusionComponentName="@thd-olt-component-react/super-sku"
        version="13.29.0"
      />
    );

  }

  if (props.slot === 'slotE9') {

    return (
      <lazySlots.LazyOrderSampleE9
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotE9"
        fusionComponentName="@thd-olt-component-react/order-sample"
        version="5.15.2"
      />
    );

  }

  if (props.slot === 'slotE10') {

    return (
      <lazySlots.LazyGlobalCustomConfiguratorE10
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotE10"
        fusionComponentName="@thd-olt-component-react/global-custom-configurator"
        version="2.5.1"
      />
    );

  }

  if (props.slot === 'slotE12') {

    return (
      <lazySlots.LazyReturnsMessagingE12
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotE12"
        fusionComponentName="@thd-olt-component-react/returns-messaging"
        version="1.13.0"
      />
    );

  }

  if (props.slot === 'slotF5') {

    return (
      <lazySlots.LazyBotPromptF5
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotF5"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="6.9.9"
      />
    );

  }

  if (props.slot === 'slotF6') {

    return (
      <LazyF6Accordion
        {...props}
        config={props.config}
        fusionSlotName="slotF6"
        fusionComponentName="accordion"
        fusionClassName={slot.fusionClassName}
        isDynamic
        // commenting inner query provider since withDynamicImport already wraps AccordionBody with inner query provider
        // queryProvider={{
        //   inherit: 'page',
        //   merge,
        //   queryOptions,
        //   cache key for all accordions must be the same
        //   otherwise a race condition will occur generating duplicate requests
        //   cacheKey: 'page',
        //   defaultVariables: props?.qctx?.defaultVariables?.current || { storeId, zipCode: storeZip }
        // }}
      />
    );

  }

  if (props.slot === 'slotF7') {

    return (
      <lazySlots.LazyBotPromptF7
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotF7"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="6.9.9"
      />
    );

  }

  return null;
};

DynamicImporter.propTypes = {
  config: PropTypes.shape({
    slots: PropTypes.shape({})
  }).isRequired,
  slot: PropTypes.string.isRequired,
};
